var _circle, _circle2, _rect;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgInfo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 6.25,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 6,
    r: 1,
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 2,
    height: 5,
    rx: 1,
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info.605006cfec86120e61734f4b2825f361.svg";